import React, { useEffect, useRef, useState } from "react";
import './index.css'
import Webcam from "react-webcam";
import axios from "axios";
import { motion } from "framer-motion";
import Confetti from 'react-confetti'
import { useScrollPage } from "./hooks/useScrollPage";



const ChampionsThrophyScreen = ()=>{
    const [matchInfo, setMatchInfo] = useState('')
    const webcamRef = useRef(null)
    const journalId = window.location?.pathname?.split('/')?.[3]

    console.log('matchInfo', matchInfo )
        useEffect(()=>{
        const url = 'https://web-production-58ed.up.railway.app/api/get/jornadabyid'
        axios.get(url, {params: {_id: journalId}}).then(res => {
            console.log('res', res)
            setMatchInfo(res.data?.jornada)
        }).catch(e => console.log(e))

    },[journalId])
    useScrollPage(200)

    return(
        <div className="container-champions-throphy">
            <Confetti colors={["#FFD700", "#000000ff", "#8e8989ff"]}/>
                  <Webcam
                    audio={false}
                    mirrored
                    screenshotFormat="image/jpeg"
                    className="webcam"
                    width={1000}
                    height={600}
                    ref={webcamRef}
                  />
                  <div className="container-champiosn-team">
                    <p  className="title-champion-challenge">CAMPEON</ p>
                    <motion.img 
                      animate={{
    filter: [
      "drop-shadow(0 0 0px gold)",
      "drop-shadow(0 0 25px gold)",
      "drop-shadow(0 0 0px gold)",
    ],
        opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }}
                    width={110} src={matchInfo?.equipoLocal?.pictureTeam} />

                  </div>

                  <div className="card-throphy-img">
                    <motion.img 
                    src={matchInfo?.torneo?.imgTrophy} 
                      initial={{
    scale: 2,
    rotate: -180,
    opacity: 0,
  }}
  animate={{
    scale: [0, 1.15, 1],
    rotate: [-180, 8, -8, 0],
    opacity: 1,
  }}
  transition={{
    duration: 1.5,
    ease: "easeOut",
  }}
                    />

                  </div>

        </div>
    )

}

export default ChampionsThrophyScreen